import { atom } from 'jotai';

/** Controls visibility of the HealthPathways zone setup dialog (EVI-1093). */
export const healthPathwaysSetupDialogOpenAtom = atom<boolean>(false);
